import type { Task } from "@medplum/fhirtypes";
import { TASK_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useTaskSubscription = createSubscriptionHook<Task>("Task", TASK_COLLECTION_NAME);
